<template>
      <div class="nvc-info max-content">
		<top title="资料下载劳务收集" :color="color"></top>
              <div class="flex">
                  <img src="//cdn.edstatic.com/203012120000/e0caffbb802e3342504accb8d68bdee4/2025/05/37a4f8e0-fe67-4a8d-9bd6-85eb37c5260d.png" @click="getButtonData(2458)" />
                  <img src="//cdn.edstatic.com/203012120000/1707582f2e7cbf1e50273996eb564c71/2025/05/58c4d73a-d42a-4fdc-8a89-f96b02e320bf.jpg" @click="getButtonData(2471)" />
                  <img src="//cdn.edstatic.com/203012120000/db7714ff15af98f1237344a3ae7aa79f/2025/05/dcaa104a-1ab7-43d4-859f-1c451bae869f.png" @click="getButtonData(2484)" alt="">
              </div>
          </div>
  </template>
  
  <script>
import {ButtonDetail} from '../../config/interface.js'
  import Top from '../VascularSystem/components/Top.vue'
	export default{
		components: {
    		Top
  		},    data() {
		return {
			meetingButton: [],    //会议按钮
			meeting_id: this.$route.query.meeting_id || '531',
            color:"rgb(122, 21, 189)"
		}
	},
      created(){
          this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
          this.getButtonData();
        
      },
       methods:{
              //获取按钮信息
              getButtonData(bid){
                  if(bid){
                      const url=ButtonDetail;
                      let params={
                          button_id:bid
                      }
                      const method="POST";
                      fetch(url,params,method)
                      .then((res)=>{
                          if(res.code==0){
                            this.$router.push(res.data.url);
                            //   document.title=res.data.share_title;
                            //   if(common.is_weixin()){
                            //       let data=res.data;
                            //       common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                            //   }
                          }
                      })
  
                  }
              },

      }
  }
  </script>
  
  <style scoped>
  /* .bg{
      background: white;
  } */
  .nvc-info{
    width: 100%;
      position: relative;
  }
  .nvc-info img{
      width: 100%;
  }

  .nvc-info .text{
      margin: 10px 0 30px;
      font-size: 13px;
      line-height: 26px;
  }
  .nvc-info .line1{
      line-height: 40px;
  }
  .nvc-info .line1 img{
      width: 20px;
      vertical-align: middle;
      line-height: 40px;
      margin-right: 10px;
  }
  .nvc-info .flex{
      width: 100%;
      padding: 20px 10%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
  }
  .nvc-info .flex img{
      width: 43%;
      margin-bottom: 10px;
  }
  .wel-text{
      background-color: #C23231;
      color: white;
      font-size: 13px;
      line-height: 30px;
  }
  .speaker-words{
      position: relative;
      font-size: 13px;
  }
  .speaker-words .bottom-icon{
      position: absolute;
      right: 0;
      width: 40px;
  }
  .text-flex{
      margin: 30px 0 20px;
  }
  .text-flex img{
      width: 29%;
      float: left;
      margin-right: 10px;
  }
  .bottom-img{
      width: 100%;
      display: block;
  }
  </style>


// WEBPACK FOOTER //
// src/pages/NVC2025/download.vue